import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["shouldBeChoreographed", "withChoreographedRender"],
  _excluded2 = ["messageType"],
  _excluded3 = ["messageType", "messageId", "onMessageDisposition"],
  _excluded4 = ["shouldBeChoreographed", "withChoreographedToggle"],
  _excluded5 = ["messageType"],
  _excluded6 = ["messageType", "messageId", "onMessageDisposition"];
import React, { useMemo } from 'react';
import { IntegratedChoreographerMessageTypesEnum } from '../constants';
export const shouldBeChoreographed = (props, coordinationOptions) => {
  return Boolean(coordinationOptions === null || coordinationOptions === void 0 ? void 0 : coordinationOptions.enableChoreographer) && (props === null || props === void 0 ? void 0 : props.messageType) !== undefined && IntegratedChoreographerMessageTypesEnum.includes(props.messageType);
};
export const wrapComponentForChoreographer = Component => {
  var _Component$displayNam;
  function WrapperComponent(_ref) {
    let {
        shouldBeChoreographed: shouldBeChoreographedProp,
        withChoreographedRender
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    const ChoreographedComponent = useMemo(() => withChoreographedRender(Component), [withChoreographedRender]);
    if (shouldBeChoreographedProp(props)) {
      // Extract messageType since it is not a property of ChoreographedComponent
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {
          messageType
        } = props,
        rest = _objectWithoutProperties(props, _excluded2);
      return /*#__PURE__*/React.createElement(ChoreographedComponent, rest);
    }

    // Extract messageType since it is not a property of the original Atlaskit component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _ref2 = props,
      {
        messageType,
        messageId,
        onMessageDisposition
      } = _ref2,
      rest = _objectWithoutProperties(_ref2, _excluded3);
    return /*#__PURE__*/React.createElement(Component, rest);
  }
  WrapperComponent.displayName = `ChoreographerWrapped${((_Component$displayNam = Component.displayName) !== null && _Component$displayNam !== void 0 ? _Component$displayNam : Component.name) || 'Component'}`;
  return WrapperComponent;
};
export const wrapToggleableComponentForChoreographer = (Component, toggleableProp) => {
  var _Component$displayNam2;
  function WrapperComponent(_ref3) {
    let {
        shouldBeChoreographed: shouldBeChoreographedProp,
        withChoreographedToggle
      } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded4);
    const ChoreographedComponent = useMemo(() => withChoreographedToggle(Component, toggleableProp), [withChoreographedToggle]);
    if (shouldBeChoreographedProp(props)) {
      // Extract messageType since it is not a property of ChoreographedComponent
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {
          messageType
        } = props,
        rest = _objectWithoutProperties(props, _excluded5);
      return /*#__PURE__*/React.createElement(ChoreographedComponent, rest);
    }

    // Extract messageType since it is not a property of the original Atlaskit component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _ref4 = props,
      {
        messageType,
        messageId,
        onMessageDisposition
      } = _ref4,
      rest = _objectWithoutProperties(_ref4, _excluded6);
    return /*#__PURE__*/React.createElement(Component, rest);
  }
  WrapperComponent.displayName = `ChoreographerWrapped${((_Component$displayNam2 = Component.displayName) !== null && _Component$displayNam2 !== void 0 ? _Component$displayNam2 : Component.name) || 'Component'}`;
  return WrapperComponent;
};